(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pure-cacao-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelector('#header-group')?.setAttribute('hidden', '');
  document.querySelector('body > footer')?.setAttribute('hidden', '');

  const initCacaoLab = (lab) => {
    if (lab.dataset.ready === 'true') return;
    lab.dataset.ready = 'true';
    const toggle = lab.querySelector('[data-dc-lab-toggle]');
    const kicker = lab.querySelector('[data-dc-lab-kicker]');
    const title = lab.querySelector('[data-dc-lab-title]');
    const copy = lab.querySelector('[data-dc-lab-copy]');
    const label = lab.querySelector('[data-dc-lab-label]');

    toggle?.addEventListener('click', () => {
      const blended = !lab.classList.contains('is-blended');
      lab.classList.toggle('is-blended', blended);
      toggle.setAttribute('aria-pressed', String(blended));
      kicker.textContent = blended ? 'Evenly dispersed' : 'Natural settling';
      title.textContent = blended ? 'Now that is a proper cup.' : 'Real cacao needs movement.';
      copy.textContent = blended
        ? 'Enjoy it warm or pour over ice. Stir again if natural settling occurs.'
        : 'Whisking can leave small clumps. Blend for one minute.';
      label.textContent = blended ? 'Let it settle' : 'Blend the cup';
    });
  };

  const initCacaoProgress = (root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const slides = [...root.querySelectorAll('[data-dc-slide]')];
    const buttons = [...root.querySelectorAll('[data-dc-button]')];
    const duration = Number(root.dataset.duration) || 5000;
    let active = 0;
    let timer;
    root.style.setProperty('--progress-duration', `${duration}ms`);

    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === active));
      buttons.forEach((button, buttonIndex) => {
        const selected = buttonIndex === active;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-selected', String(selected));
      });
      window.clearTimeout(timer);
      timer = window.setTimeout(() => show(active + 1), duration);
    };

    buttons.forEach((button, index) => button.addEventListener('click', () => show(index)));
    show(0);
  };

  document.querySelectorAll('[data-dc-lab]').forEach(initCacaoLab);
  document.querySelectorAll('[data-dc-progress]').forEach(initCacaoProgress);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-dc-lab]').forEach(initCacaoLab);
    event.target.querySelectorAll('[data-dc-progress]').forEach(initCacaoProgress);
  });

  } catch(e) { console.error(e); }
})();
})();
